export const USER_DETAILS_FORM_FIELDS = {
    full_name: "full_name",
    email: "email",
    phone: "phone",
    country: "country", // Name. Eg: India
    country_code: "country_code", // Code. Eg: +91
};
